// Comparação simples de semver (major.minor.patch), sem suporte a
// pre-release/build metadata — suficiente para o gate de versão do app.
export function compareVersions(a, b) {
    const pa = String(a).split('.').map((n) => parseInt(n, 10) || 0);
    const pb = String(b).split('.').map((n) => parseInt(n, 10) || 0);
    for (let i = 0; i < 3; i++) {
        const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
        if (diff !== 0) return diff < 0 ? -1 : 1;
    }
    return 0;
}

export const isVersionBelow = (version, threshold) => compareVersions(version, threshold) < 0;
